(function() {
    'use strict';
    angular
        .module('atheer.services')
        .factory('Badge', Badge);


    /* @ngInject */
    function Badge($resource) {
        var resourceUrl = 'api/badges/:id';

        return $resource(resourceUrl, {
            id: '@id'
        }, {
            'query': {
                method: 'GET',
                isArray: true
            },
            'get': {
                method: 'GET',
                transformResponse: function(data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'update': {
                method: 'PUT'
            }
        });
    }
})();
